import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect, memo, useContext, useMemo} from 'react';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import HomepageCellcomTvBlockData from 'Models/Content/HomepageCellcomTvBlockData';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import {HomepageCellcomTvContext} from './HomepageCellcomTvContext';
import classNames from 'classnames';
import {getImageProps} from 'app/utilities/ImageProps';
import {isMobile} from 'react-device-detect';

const HomepageCellcomTvBlockWrapper = ({data, context}: ComponentProps<HomepageCellcomTvBlockData>) => {
  const {transparent} = useContext(HomepageCellcomTvContext);
  const contentAreaMemo = useMemo(() => <ContentArea noWrap context={context} data={data.lItems} />, [data.lItems]);

  return (
    <div className={classNames('HomepageCellcomTvBlock')}>
      <Image className={classNames('HomepageCellcomTvBlock__background')}
        {...getImageProps(isMobile ? data.mobileBlockBackGroundImage : data.blockBackGroundImage, context)} />
      <h2>{data.title.value}</h2>
      <p className='HomepageCellcomTvBlock__subtitle'>{data.blockSubtitle.value}</p>
      {data.link.value && (
        <a href={data.link.value} className='HomepageCellcomTvBlock__button'>
          {data.linkTitle.value || 'הכירו את סלקום TV'}
        </a>
      )}
      {contentAreaMemo}
    </div>
  );
};

const HomepageCellcomTvBlock = ({data, context}: ComponentProps<HomepageCellcomTvBlockData>) => {
  const [visible, setVisible] = useState(true);
  const [transparent, setTransparent] = useState(true);

  useEffect(() => {
    if (visible) {
      setTransparent(false);
    }
  }, [visible]);

  return (
    <HomepageCellcomTvContext.Provider value={{setVisible, visible, transparent}}>
      <HomepageCellcomTvBlockWrapper data={data} context={context} />
    </HomepageCellcomTvContext.Provider>
  );
};

export default memo(HomepageCellcomTvBlock);
